import { Editor, useEditorState } from '@tiptap/react'
import { Select } from 'antd'

import { useStyles } from './styles'

type Props = {
  editor: Editor
}

const headingOptions = [
  { label: 'Paragraph', value: 'paragraph' },
  { label: 'Heading 1', value: 'heading1' },
  { label: 'Heading 2', value: 'heading2' },
  { label: 'Heading 3', value: 'heading3' },
  { label: 'Heading 4', value: 'heading4' },
  { label: 'Heading 5', value: 'heading5' },
  { label: 'Heading 6', value: 'heading6' }
]

export const HeadingSelect = ({ editor }: Props) => {
  const { styles } = useStyles()

  const editorState = useEditorState({
    editor,
    selector: (ctx) => {
      return {
        isParagraph: ctx.editor.isActive('paragraph') ?? false,
        isHeading1: ctx.editor.isActive('heading', { level: 1 }) ?? false,
        isHeading2: ctx.editor.isActive('heading', { level: 2 }) ?? false,
        isHeading3: ctx.editor.isActive('heading', { level: 3 }) ?? false,
        isHeading4: ctx.editor.isActive('heading', { level: 4 }) ?? false,
        isHeading5: ctx.editor.isActive('heading', { level: 5 }) ?? false,
        isHeading6: ctx.editor.isActive('heading', { level: 6 }) ?? false
      }
    }
  })

  const getCurrentHeadingValue = () => {
    if (editorState.isHeading1) return 'heading1'
    if (editorState.isHeading2) return 'heading2'
    if (editorState.isHeading3) return 'heading3'
    if (editorState.isHeading4) return 'heading4'
    if (editorState.isHeading5) return 'heading5'
    if (editorState.isHeading6) return 'heading6'
    return 'paragraph'
  }

  const onHeadingChange = (value: string) => {
    if (value === 'paragraph') {
      editor.chain().focus().setParagraph().run()
    } else if (value.startsWith('heading')) {
      const level = parseInt(value.replace('heading', '')) as
        | 1
        | 2
        | 3
        | 4
        | 5
        | 6
      editor.chain().focus().setHeading({ level }).run()
    }
  }

  return (
    <Select
      value={getCurrentHeadingValue()}
      options={headingOptions}
      onChange={onHeadingChange}
      className={styles.headingSelect}
    />
  )
}
